import { GHLLanguageKeys as e } from "./ghl-ui.es285.js";
const r = {
  name: e.portugueseBrazil,
  global: {
    undo: "Desfazer",
    redo: "Refazer",
    confirm: "Confirmar",
    clear: "Limpar",
    more: "mais",
    cancel: "Cancelar"
  },
  Popconfirm: {
    positiveText: "Confirmar",
    negativeText: "Cancelar"
  },
  Cascader: {
    placeholder: "Por favor, selecione",
    loading: "Carregando",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy/MM",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "yyyy/qqq",
    clear: "Limpar",
    now: "Agora",
    confirm: "Confirmar",
    selectTime: "Selecionar Horário",
    selectDate: "Selecionar Data",
    datePlaceholder: "Selecionar Data",
    datetimePlaceholder: "Selecionar Data e Hora",
    monthPlaceholder: "Selecionar Mês",
    yearPlaceholder: "Selecionar Ano",
    quarterPlaceholder: "Selecionar Trimestre",
    startDatePlaceholder: "Data de Início",
    endDatePlaceholder: "Data Final",
    startDatetimePlaceholder: "Data e Hora Inicial",
    endDatetimePlaceholder: "Data e Hora Final",
    startMonthPlaceholder: "Mês de Início",
    endMonthPlaceholder: "Mês Final",
    monthBeforeYear: !0,
    firstDayOfWeek: 6,
    today: "Hoje"
  },
  DataTable: {
    checkTableAll: "Selecionar tudo na tabela",
    uncheckTableAll: "Desmarcar tudo na tabela",
    confirm: "Confirmar",
    clear: "Limpar",
    apply: "Aplicar",
    filters: "Filtros",
    sort: "Ordenar"
  },
  LegacyTransfer: {
    sourceTitle: "Origem",
    targetTitle: "Destino"
  },
  Transfer: {
    selectAll: "Selecionar tudo",
    unselectAll: "Desmarcar tudo",
    clearAll: "Limpar"
  },
  Empty: {
    description: "Sem Dados"
  },
  Select: {
    placeholder: "Por favor, selecione"
  },
  TimePicker: {
    placeholder: "Selecionar Horário",
    positiveText: "OK",
    negativeText: "Cancelar",
    now: "Agora"
  },
  Pagination: {
    goto: "Ir para",
    selectionSuffix: "página",
    next: "Próximo",
    previous: "Anterior"
  },
  DynamicTags: {
    add: "Adicionar"
  },
  Log: {
    loading: "Carregando"
  },
  Input: {
    placeholder: "Por favor, insira"
  },
  InputNumber: {
    placeholder: "Por favor, preencha"
  },
  DynamicInput: {
    create: "Criar"
  },
  ThemeEditor: {
    title: "Editor de Tema",
    clearAllVars: "Limpar todas as variáveis",
    clearSearch: "Limpar Busca",
    filterCompName: "Filtrar Nome do Componente",
    filterVarName: "Filtrar Nome da Variável",
    import: "Importar",
    export: "Exportar",
    restore: "Redefinir para o Padrão"
  },
  Image: {
    tipPrevious: "Imagem Anterior (←)",
    tipNext: "Próxima Imagem (→)",
    tipCounterclockwise: "Sentido Anti-horário",
    tipClockwise: "Sentido Horário",
    tipZoomOut: "Reduzir Zoom",
    tipZoomIn: "Aumentar Zoom",
    tipClose: "Fechar (Esc)",
    tipOriginalSize: "Zoom para Tamanho Original"
  },
  SortFilter: {
    heading: "Classificar e filtrar",
    sortHeading: "Classificar por",
    newestFirst: "Mais recentes primeiro",
    oldestFirst: "Mais antigos primeiro",
    ascending: "Crescente",
    descending: "Decrescente",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Aplicar",
    clear: "Limpar",
    cancel: "Cancelar",
    filters: "Filtros"
  },
  IconPicker: {
    noMatchingFound: "Nenhum resultado correspondente encontrado"
  },
  Spacing: {
    margin: "Margem",
    padding: "Preenchimento",
    reset: "Resetar",
    errorMsg: "O valor fornecido é inválido."
  },
  BrandColorPicker: {
    brandColors: "Cores da marca",
    noBrandColors: "Você ainda não adicionou nenhuma cor de marca.",
    getStarted: "Começar",
    add: "Adicionar",
    default: "Padrão"
  }
};
export {
  r as ptBR
};
